import React from 'react';
import './AwesomeTour.css';
import image from '../../images/awesome-tour/fantastic-tour-pic.jpg';

const AwesomeTour = () => {
    return (
        <div className="awesome-tour-container shadow-lg">
            <div className="awesomeTour">
                <div>
                    <img className="img" src={image} alt="" />
                </div>
                <div className="awesomeTour-title">
                    <h1>Go Ahead & Make Awesome Tour</h1>
                    <h4>Discover Hidden Wonders On Trips With Peulis</h4>
                    <button className="button">Explore More</button>
                </div>
            </div>
        </div>
    );
};

export default AwesomeTour;